// @ts-nocheck
class PreviewMediaModel {
	constructor(senderName, initials, type, source, timestamp) {
		this.senderName = senderName;
		this.initials = initials;
		this.type = type;
		this.source = source;
		this.timestamp = timestamp;
	}
}

export default PreviewMediaModel;
